import styled, { keyframes } from 'styled-components';
const animation = (fadeIn: string, fadeOut: string) => keyframes`
  	from {
${fadeIn}
	}
	to {
${fadeOut}
	}
`;
export const BuildTipWrapper = styled.div<{
	top: string;
	left: string;
	hideBuildTip: boolean;
}>`
	position: absolute;
	top: ${(props) => props.top};
	left: ${(props) => props.left};
	z-index: 4;
	width: 100px;
	animation: ${(props) =>
		animation(
			'opacity: ' + (props.hideBuildTip ? '1' : '0') + ';',
			'opacity: ' + (props.hideBuildTip ? '0' : '1') + ';'
		)};
	animation-duration: 3s;
`;
